import clsx from "clsx";
import { useEffect } from "react";
import { createPortal } from "react-dom";

interface ModalProps {
  children: React.ReactNode;
  isOpen: boolean;
  onClose: () => void;
  scrollable?: boolean;
  className?: string;
  fullHeight?: boolean;
}

const Modal = ({
  children,
  isOpen,
  onClose,
  className,
  scrollable = true,
  fullHeight,
}: ModalProps) => {
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === "Escape") {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener("keydown", handleKeyDown);
    }

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [isOpen, onClose]);

  if (!isOpen) {
    return null;
  }

  return createPortal(
    <>
      <div
        className="fixed top-0 left-0 right-0 bottom-0 bg-black opacity-50 z-9999"
        onClick={onClose}
      />
      <div
        className={clsx(
          "fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 p-6 rounded-lg z-10000",
          "dark:text-stone-100 dark:bg-stone-900 text-stone-800 bg-stone-50",
          scrollable && "overflow-x-hidden",
          scrollable && (fullHeight ? "overflow-y-scroll" : "overflow-y-auto"),
          "max-h-[90vh]",
          fullHeight && "min-h-[90vh]",
          className,
        )}
      >
        {children}
      </div>
    </>,
    document.body,
  );
};

export default Modal;
